(function () {
  function normalizeSrc(src) {
    if (!src) return '';
    const resolved = src.indexOf('//') === 0 ? window.location.protocol + src : src;
    return resolved.replace('https://tendersounds.co.uk/cdn/shop/', 'https://cdn.shopify.com/s/files/1/0753/8553/6815/');
  }

  function initGallery(section) {
    if (!section || section.dataset.tsPdpGalleryReady === 'true') return;

    const mainButton = section.querySelector('[data-tspdp-gallery-main]');
    const mainImage = section.querySelector('[data-tspdp-gallery-image]');
    const thumbs = Array.from(section.querySelectorAll('[data-tspdp-gallery-thumb]'));
    const modal = section.querySelector('[data-tspdp-gallery-modal]');
    const modalImage = section.querySelector('[data-tspdp-gallery-modal-image]');
    const closeButton = section.querySelector('[data-tspdp-gallery-close]');
    const prevButton = section.querySelector('[data-tspdp-gallery-prev]');
    const nextButton = section.querySelector('[data-tspdp-gallery-next]');
    const counter = section.querySelector('[data-tspdp-gallery-counter]');

    if (!mainImage) return;

    section.dataset.tsPdpGalleryReady = 'true';
    /* ts-pdp-canonical-cdn-fallback-20260724 */
    let canonicalMainSrc = normalizeSrc(mainImage.currentSrc || mainImage.src);
    if (canonicalMainSrc && canonicalMainSrc !== mainImage.src) mainImage.src = canonicalMainSrc;
    let currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true'));

    const images = thumbs.length
      ? thumbs.map((thumb) => ({
          thumb,
          src: normalizeSrc(thumb.dataset.src),
          fullSrc: normalizeSrc(thumb.dataset.fullSrc || thumb.dataset.src),
          alt: thumb.dataset.alt || mainImage.alt || '',
        }))
      : [
          {
            thumb: null,
            src: mainImage.currentSrc || mainImage.src,
            fullSrc: mainImage.currentSrc || mainImage.src,
            alt: mainImage.alt || '',
          },
        ];

    let mainImageRequest = 0;
    let modalImageRequest = 0;

    function setImageSource(target, primarySrc, fallbackSrc, requestId, isCurrent) {
      if (!target || !primarySrc) return;
      const loader = new Image();
      let fallbackTried = false;

      const apply = (src) => {
        if (isCurrent && !isCurrent()) return;
        target.removeAttribute('srcset');
        target.removeAttribute('sizes');
        target.src = src;
        target.removeAttribute('aria-busy');
      };

      loader.onload = () => apply(loader.src);
      loader.onerror = () => {
        if (!fallbackTried && fallbackSrc && fallbackSrc !== primarySrc) {
          fallbackTried = true;
          loader.src = fallbackSrc;
          return;
        }
        if (isCurrent && isCurrent()) target.removeAttribute('aria-busy');
      };
      loader.src = primarySrc;
    }

    function setMainImage(index) {
      if (!images[index]) return;
      currentIndex = index;
      const item = images[index];
      const requestId = ++mainImageRequest;
      const primarySrc = item.fullSrc || item.src;
      const fallbackSrc = item.src || item.fullSrc;

      mainImage.alt = item.alt;
      mainImage.setAttribute('aria-busy', 'true');
      setImageSource(mainImage, primarySrc, fallbackSrc, requestId, () => requestId === mainImageRequest);

      thumbs.forEach((thumb, thumbIndex) => {
        thumb.setAttribute('aria-current', thumbIndex === currentIndex ? 'true' : 'false');
      });
    }

    function updateModal() {
      if (!modal || !modalImage || !images[currentIndex]) return;
      const item = images[currentIndex];
      const requestId = ++modalImageRequest;
      const primarySrc = item.fullSrc || item.src;
      const fallbackSrc = item.src || item.fullSrc;

      modalImage.alt = item.alt;
      modalImage.setAttribute('aria-busy', 'true');
      setImageSource(modalImage, primarySrc, fallbackSrc, requestId, () => requestId === modalImageRequest);
      if (counter) counter.textContent = `${currentIndex + 1} / ${images.length}`;
    }

    function openModal() {
      if (!modal || !modalImage) return;
      updateModal();
      modal.hidden = false;
      document.documentElement.classList.add('ts-gallery-open');
      if (closeButton) closeButton.focus({ preventScroll: true });
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('ts-gallery-open');
      if (mainButton) mainButton.focus({ preventScroll: true });
    }

    function step(offset) {
      if (!images.length) return;
      const nextIndex = (currentIndex + offset + images.length) % images.length;
      setMainImage(nextIndex);
      updateModal();
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => setMainImage(index));
    });

    if (mainButton) mainButton.addEventListener('click', openModal);
    if (closeButton) closeButton.addEventListener('click', closeModal);
    if (prevButton) prevButton.addEventListener('click', () => step(-1));
    if (nextButton) nextButton.addEventListener('click', () => step(1));
    if (modal) {
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });
    }

    section.addEventListener('keydown', (event) => {
      if (!modal || modal.hidden) return;
      if (event.key === 'Escape') closeModal();
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.ts-pdp').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();


/* ts-gallery-large-image-fallback-20260723 */